import { ATTRIBUTE_KINDS } from '../constants';
import type { ConversationAttributeItem } from '../api/types';

/**
 * Хранит ли диалог собственное значение этого атрибута.
 *
 * Системный атрибут верхнего уровня значения не хранит: он либо отвечает полем самой записи
 * диалога, либо не отвечает ничем — и там, где значение берут из значений диалога (сопоставление
 * полей касания), он всегда пуст. Вложенные системные атрибуты (речевая аналитика) хранятся как
 * обычные, поэтому исключается только верхний уровень: путь к нему — его собственный код,
 * без цепочки владельцев.
 */
export const hasOwnAttributeValue = (attribute: ConversationAttributeItem): boolean =>
  attribute.type !== ATTRIBUTE_KINDS.SYSTEM || attribute.path.includes('.');
